module.exports = __webpack_public_path__ + "static/media/createBatchKan.0525395c.jpg";